<template>
  <b-button
    variant="info"
    @click="goTo"
  >
    <b-icon-pencil
      class="mr-1" />
    編集
  </b-button>
</template>

<script>
export default {
  props: {
    id: {
      type: Number,
      required: true
    }
  },

  data () {
    return {
      modelName: 'users'
    }
  },

  methods: {
    goTo () {
      this.$router.push({
        name: `${this.modelName}-edit`,
        params: {
          id: this.id
        }
      })
    }
  }
}
</script>
